import React, { Fragment, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useHistory } from 'react-router-dom'

import SignIn61 from '../components/sign-in61'
import { login } from '../services/auth.service'
import './login.css'

const Login: React.FC = () => {
  const [error, setError] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const history = useHistory()

  const handleLogin = async (username: string, password: string): Promise<void> => {
    try {
      setLoading(true)
      setError('')
      const loggedIn = await login(username, password)
      if (loggedIn.user?.role === 'admin_finca') {
        history.push('/inventario-finca')
      } else {
        history.push('/menu')
      }
    } catch (err) {
      setError('Invalid username or password')
      console.error('Login error:', err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-container">
      <Helmet>
        <title>Login - ProyectoGanando</title>
        <meta property="og:title" content="Login - ProyectoGanando" />
      </Helmet>
      <SignIn61
        text={
          <Fragment>
            <span className="login-text1">Esconder</span>
          </Fragment>
        }
        action1={
          <Fragment>
            <span className="login-text2">Ingresar</span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="login-text3">Bienvenido</span>
          </Fragment>
        }
        image1Src="/siare-1500w.jpg"
        rootClassName="sign-in61root-class-name"
        onLogin={handleLogin}
        error={error}
        loading={loading}
      />
    </div>
  )
}

export default Login

